module.exports = __webpack_public_path__ + "static/media/noa_longsleeve_back.5567294a.jpg";